module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contributor-section"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content content"
  }, [_c('h5', [_vm._v("特别感谢")]), _vm._v(" "), _c('ul', _vm._l((_vm.contributors), function(user, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": '/user/' + user.id
      }
    }, [_c('p', [_vm._v(_vm._s(user.id) + " ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.work))])], 1)
  }))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item button is-primary",
    attrs: {
      "href": "https://github.com/paper777/yamb"
    }
  }, [_vm._v("参与开发")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a6c60ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contributor.vue
// module id = 246
// module chunks = 1